var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceNosmoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.50399C2.448 8.50399 2 8.95199 2 9.50399V10.504C2 11.056 2.448 11.504 3 11.504L15.5 11.498V8.49799L3 8.50399ZM14.5 10.498L5 10.504V9.50399L14.5 9.49799V10.498Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.504H16V11.504H17.5V8.504Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.504H3C2.448 11.504 2 11.056 2 10.504V9.504C2 8.952 2.448 8.504 3 8.504H7V11.504Z",
    fill: "#FFC629"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.788 6.59201C14.794 6.59801 14.802 6.60201 14.808 6.60801C14.802 6.60201 14.796 6.59601 14.788 6.59201Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.21 7.408C14.204 7.402 14.196 7.398 14.19 7.392C14.198 7.398 14.204 7.404 14.21 7.408Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.998 7.5C4.978 5.152 7.296 3.5 9.99999 3.5C12.704 3.5 15.022 5.152 16.002 7.5H17.602C16.552 4.306 13.546 2 9.99999 2C6.454 2 3.448 4.306 2.398 7.5H3.998Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 12.5C15.022 14.848 12.704 16.5 9.99999 16.5C7.296 16.5 4.978 14.848 3.998 12.5H2.398C3.448 15.694 6.454 18 9.99999 18C13.546 18 16.552 15.694 17.602 12.5H16.002Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6601 5.25979L14.598 4.19772L3.83734 14.9584L4.89941 16.0205L15.6601 5.25979Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceNosmoke);
export default __webpack_public_path__ + "static/media/vip-lounge-service-nosmoke.32252fc323e5ac34ae504c014aa2c6a4.svg";
export { ForwardRef as ReactComponent };